import axiosInstance from '../axiosInterceptor/axiosInstance'

const deleteOrgClub = async (data) => {
  const { orgId, clubId } = data
  return axiosInstance.delete(`v1/orgs/${orgId}/clubs/${clubId}`)
}

export default deleteOrgClub
